<template>
  <div>
    <el-dialog
      :title="this.isCreated ? '新增累计充值进度配置' : '编辑累计充值进度配置'"
      center
      :visible="true"
      @close="onClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="701px"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="100px"
        size="mini"
        style="margin-right: 50px"
      >
        <el-form-item label="阶段：" prop="stage">
          <el-input style="width: 120px" v-model="form.stage"></el-input>
        </el-form-item>
        <el-form-item label="金额：" prop="condition">
          <el-input style="width: 120px" v-model="form.condition"></el-input>
        </el-form-item>
        <el-form-item label="奖励：">
          <base-item-selector
            @updated="updatedItemSelector"
            v-model="form.reward"
          ></base-item-selector>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="this.onClose">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const util = require("@/util");
import BaseItemSelector from "../biz-components/BaseItemSelector";

// 本弹窗名称
const DialogName = "EditCumulativeRechargeOfLimitTimeDialog";
export default {
  data() {
    return {
      form: {
        stage: "",
        condition: "",
        reward: [],
      },
      isCreated: false,
      itemSelectorResult: [],
    };
  },

  computed: {},

  async created() {
    let value = this.$dialogutil.getData(DialogName);
    if (value.entry != null) {
      this.form = value.entry;
    }
    this.isCreated = value.isCreated;
  },
  components: {
    BaseItemSelector,
  },

  methods: {
    /**
     * 编辑线上活动
     * @param {*} entry
     */
    async submit() {
      if (this.isCreated) {
        await this.add();
      } else {
        await this.update();
      }
    },

    async add() {
      try {
        // 弹确认框
        await this.$confirm(
          `确认新增（该操作不会真的保存配置，需要在上一级页面中保存）？`
        );

        let param = this.save();
        if (param.errMsg) {
          this.$message({
            message: param.errMsg,
            type: "error",
          });
          return;
        }
        this.$message({
          message: "新增成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onCloseWhitParam(param);
      } catch (e) {}
    },
    async update() {
      try {
        // 弹确认框
        await this.$confirm(
          `确认修改（该操作不会真的保存配置，需要在上一级页面中保存）？`
        );

        let param = this.save();

        if (param.errMsg) {
          this.$message({
            message: param.errMsg,
            type: "error",
          });
          return;
        }
        this.$message({
          message: "修改成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onCloseWhitParam(param);
      } catch (e) {}
    },

    save() {
      let stage = parseInt(this.form.stage);
      if (isNaN(stage) || stage <= 0 || stage.toString() != this.form.stage) {
        return { errMsg: "阶段必须是一个正整数" };
      }

      let condition = Number(this.form.condition);
      if (isNaN(condition) || condition <= 0) {
        return { errMsg: "金额必须是一个大于0的数" };
      }
      if (this.itemSelectorResult.errMsg) {
        return { errMsg: this.itemSelectorResult.errMsg };
      }

      let reward = this.itemSelectorResult;
      if (reward.length == 0) {
        return { errMsg: "奖励最少配置一项" };
      }

      return {
        stage: stage,
        condition: condition,
        reward: reward,
      };
    },

    async updatedItemSelector(param) {
      this.itemSelectorResult = param;
    },

    ms2ymdhm(ts) {
      return util.ms2ymdhm(ts);
    },

    onClose() {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName);
    },
    onCloseWhitParam(param) {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName, param);
    },
  },
};
</script>

<style lang="scss" scoped>
.switch-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}
.switch-status-tag-off {
  background-color: lightgray;
  border-color: lightgray;
}
.switch-status-tag-on {
  background-color: chartreuse;
  border-color: chartreuse;
}
</style>

